import React, { useRef } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { message } from 'antd'
import { useLocalization } from '@contexts/LocalizationContext'
import PageLayout from '@layouts/PageLayout'
import FormComponent from './Form'
import Fetch from '@components/CRUD/Fetch'
import { client } from '@utils/client'

const Edit = () => {
  const history = useHistory()
  const fetchRef = useRef(null)
  const params = useParams()
  const { t } = useLocalization()

  const handleSubmit = async (data) => {
    try {
      await client.patch(`/hospital/${params.id}`, data)
      message.success('สำเร็จ')
      history.push(`/hospitals/${params.id}`)
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  const fetch = async () => {
    const data = await client
      .get(`/hospital/${params.id}`)
      .then((res) => res.data)
    const s = await client.get('/specialist').then((res) => res.data)
    const specialties = s.data.map((item) => ({
      label: item.name,
      value: item.id,
    }))
    return { data, specialties }
  }

  return (
    <Fetch fetch={fetch} ref={fetchRef}>
      {({ data, specialties }) => (
        <PageLayout title={t('hospital.editScreen.title')} extra={[]}>
          <FormComponent
            specialties={specialties}
            defaultValues={data}
            handleSubmit={handleSubmit}
          />
        </PageLayout>
      )}
    </Fetch>
  )
}

export default Edit
